import { useNavigate, useLocation } from "react-router-dom";
import {
  FaGithub,
  FaTwitter,
  FaLinkedin,
  FaPhotoVideo,
  FaPenAlt,
  FaAddressCard,
  FaHome,
} from "react-icons/fa";
import "./index.css";

export const App = () => {
  return (
    <>
      {/*<div class="scanlines"></div>

      <div class="intro-wrap">
        <div class="play  play-font" data-splitting>
          PLAY
        </div>
        <div class="time">--:--</div>
        <div class="recordSpeed">SLP 0:00:00</div>
      </div>*/}

      <div className="main-content max-w-2xl mx-auto px-8 py-16 min-h-[95vh] play-font3">
        <div className="flex flex-col">
          <TopBar />
          <div className="flex gap-x-4">
            <img
              className="rounded-lg w-[120px] h-[120px]"
              src="/prof-pic3.png"
              alt="profile picture"
            />
            <div className="flex flex-col play-font2">
              <div className="text-4xl text-center mb-4 text-start">
                Hey I'm Alec
              </div>
              <div className="text-xl text-center mb-4 text-start ">
                I like to build, travel, and be by/on the water. Connect with me
                on{" "}
                <a className="text-fuchsia-500" href="https://x.com/acharbohno">
                  twitter
                </a>{" "}
                to get in touch.
              </div>
            </div>
          </div>

          <div className="my-4 text-lg play-font2">📍 USA</div>
          <div className="flex gap-x-1">
            {" "}
            <a
              href="https://github.com/acharb"
              className={`cursor-pointer hover:bg-fuchsia-800 hover:border-gray-300 py-1 px-1 rounded-lg`}
            >
              <FaGithub size={24} />
            </a>
            <a
              href="https://x.com/acharbohno"
              className={`cursor-pointer hover:bg-fuchsia-800 hover:border-gray-300  py-1 px-1 rounded-lg`}
            >
              <FaTwitter size={24} />
            </a>
            <a
              href="https://www.linkedin.com/in/aleccharbonneau/"
              className={`cursor-pointer hover:bg-fuchsia-800 hover:border-gray-300  py-1 px-1 rounded-lg`}
            >
              <FaLinkedin size={24} />
            </a>
          </div>

          <div className="my-12">
            <h1 className="my-4 tracking-tight text-3xl underline">
              Latest Projects
            </h1>

            <a
              href="https://www.etherealize.com/?utm_source=acharbohno.com"
              className="my-4 flex flex-col text-gray-300"
            >
              <div className="my-2 flex flex-col-reverse sm:flex-row justify-between hover:text-white cursor-pointer hover:underline">
                <div className="flex flex-col">
                  <div className="text-white text-xl">Etherealize</div>
                  <div className="max-w-[400px]">Founding Engineer</div>
                </div>

                <div className="text-fuchsia-500">July 2025</div>
              </div>
              <div className="flex gap-x-2">
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Ethereum
                </div>
              </div>
            </a>

            <a
              href="https://devlist.co/?utm_source=acharbohno.com"
              className="my-4 flex flex-col text-gray-300"
            >
              <div className="my-2 flex flex-col-reverse sm:flex-row justify-between hover:text-white cursor-pointer hover:underline">
                <div className="flex flex-col">
                  <div className="text-white">Dev List (sold)</div>
                  <div className="max-w-[400px]">
                    Solo built an AI engine for job matching and resume
                    optimization (bootstrapped, profitable, 15k+ engineers)
                  </div>
                </div>

                <div className="text-fuchsia-500">April 2024</div>
              </div>
              <div className="flex gap-x-2">
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Next.js
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Postgres
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  AI
                </div>
              </div>
            </a>
            <a
              href="https://github.com/stellar/typescript-wallet-sdk"
              className="my-4 flex flex-col text-gray-300 hover:text-white cursor-pointer"
            >
              <div className="my-2 flex flex-col-reverse sm:flex-row justify-between hover:text-white cursor-pointer hover:underline">
                <div>
                  <div className="text-white ">
                    Stellar - Typescript Wallet SDK
                  </div>
                  <div>SDK for building wallets on the Stellar Blockchain</div>
                </div>

                <div className="text-fuchsia-500">February 2023</div>
              </div>
              <div className="flex gap-x-2">
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  JavaScript
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  TypeScript
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Node.js
                </div>
              </div>
            </a>
            <a
              href="https://github.com/stellar/freighter"
              className="my-4 flex flex-col text-gray-300 hover:text-white cursor-pointer"
            >
              <div className="my-2 flex flex-col-reverse sm:flex-row justify-between hover:text-white cursor-pointer hover:underline">
                <div className="flex flex-col max-w-[100%] sm:max-w-[70%]">
                  <div className="text-white ">Stellar - Freighter</div>
                  <div>
                    Browser extension for Stellar blockchain (think Metamask but
                    for Stellar)
                  </div>
                </div>

                <div className="text-fuchsia-500">January 2022</div>
              </div>
              <div className="flex gap-x-2">
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  TypeScript
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  React
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Browser Extension
                </div>
              </div>
            </a>
            <a
              href="https://github.com/stellar/starlight"
              className="my-4 flex flex-col text-gray-300 hover:text-white cursor-pointer"
            >
              <div className="my-2 flex flex-col-reverse sm:flex-row justify-between hover:text-white cursor-pointer hover:underline">
                <div className="flex flex-col max-w-[100%] sm:max-w-[70%]">
                  <div className="text-white ">Stellar - Starlight</div>
                  <div>
                    First layer 2 implementation for Stellar (think Bitcoin's
                    lightning network but for Stellar)
                  </div>
                </div>

                <div className="text-fuchsia-500">May 2021</div>
              </div>
              <div className="flex gap-x-2">
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Golang
                </div>
              </div>
            </a>
            <a
              href="https://www.assurely.com/"
              className="my-4 flex flex-col text-gray-300 hover:text-white cursor-pointer"
            >
              <div className="my-2 flex flex-col-reverse sm:flex-row justify-between hover:text-white cursor-pointer hover:underline">
                <div className="flex flex-col">
                  <div className="text-white ">Assurely</div>
                  <div>Insurtech platform</div>
                </div>

                <div className="text-fuchsia-500">September 2019</div>
              </div>
              <div className="flex gap-x-2">
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Ruby on Rails
                </div>
              </div>
            </a>
            <a
              href="https://www.circle.com/en/"
              className="my-4 flex flex-col text-gray-300 hover:text-white cursor-pointer"
            >
              <div className="my-2 flex flex-col-reverse sm:flex-row justify-between hover:text-white cursor-pointer hover:underline">
                <div className="flex flex-col">
                  <div className="text-white ">
                    Circle - Equity Crowfunding Arm (Formerly SeedInvest)
                  </div>
                  <div>Equity Crowdfunding platform</div>
                </div>

                <div className="text-fuchsia-500">March 2019</div>
              </div>
              <div className="flex gap-x-2">
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Python
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  JavaScript
                </div>
                <div className="bg-fuchsia-950 text-fuchsia-400 rounded-xl px-2 w-[fit-content]">
                  Angular
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <BottomBar />
    </>
  );
};

export const BottomBar = () => {
  return (
    <div>
      <div className="w-full flex items-center justify-center py-4">
        <div className="flex gap-x-8 w-[fit-content]">
          {" "}
          <a
            href="https://github.com/acharb"
            className={`cursor-pointer hover:bg-fuchsia-800 hover:border-gray-300 py-1 px-1 rounded-lg`}
          >
            <FaGithub size={30} />
          </a>
          <a
            href="https://x.com/acharbohno"
            className={`cursor-pointer hover:bg-fuchsia-800 hover:border-gray-300  py-1 px-1 rounded-lg`}
          >
            <FaTwitter size={30} />
          </a>
          <a
            href="https://www.linkedin.com/in/aleccharbonneau/"
            className={`cursor-pointer hover:bg-fuchsia-800 hover:border-gray-300  py-1 px-1 rounded-lg`}
          >
            <FaLinkedin size={30} />
          </a>
        </div>
      </div>
    </div>
  );
};

export const TopBar = () => {
  const navigate = useNavigate();
  const { pathname: path } = useLocation();

  return (
    <div className="flex gap-x-8 justify-center pb-12 pt-4">
      <a
        onClick={() => {
          navigate("/");
        }}
        className={`${
          path === "/" ? "bg-gray-800" : ""
        } cursor-pointer hover:bg-gray-800 hover:border-gray-300  py-2 px-4 rounded-lg`}
      >
        <FaHome size={28} />
      </a>
      <a
        onClick={() => {
          navigate("/about");
        }}
        className={`${
          path === "/about" ? "bg-gray-800" : ""
        } cursor-pointer hover:bg-gray-800 hover:border-gray-300  py-2 px-4 rounded-lg`}
      >
        <FaAddressCard size={28} />
      </a>
      <a
        onClick={() => {
          navigate("/writings");
        }}
        className={`${
          path === "/writings" ? "bg-gray-800" : ""
        } cursor-pointer hover:bg-gray-800 hover:border-gray-300  py-2 px-4 rounded-lg`}
      >
        <FaPenAlt size={28} />
      </a>
      <a
        onClick={() => {
          navigate("/videos");
        }}
        className={`${
          path === "/videos" ? "bg-gray-800" : ""
        } cursor-pointer hover:bg-gray-800 hover:border-gray-300  py-2 px-4 rounded-lg`}
      >
        <FaPhotoVideo size={28} />
      </a>
    </div>
  );
};
